// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M8 9l4-4 4 4m0 6l-4 4-4-4\"/> </svg> ";
// Exports
module.exports = code;